import { IBFFOptions } from "../interfaces/interfaces";

export async function fetchFromBFF(endpoint: string, options: IBFFOptions = {}): Promise<any> {
    const isDebug = process.env.NODE_ENV === 'development';
    const bffUrl = isDebug ? 'http://localhost:3001' : '/api';

    // Pulizia dell'endpoint: evita doppi slash //
    const cleanEndpoint = endpoint.startsWith('/') ? endpoint.substring(1) : endpoint;
    const url = `${bffUrl}/${cleanEndpoint}`;

    try {
        const method = options.method?.toUpperCase() || 'GET';

        // Imposta il body solo se non è una GET
        const hasBody = options.body && method !== 'GET';

        const response = await fetch(url, {
            credentials: 'include',
            method: method,
            headers: {
                // Aggiungiamo Content-Type solo se stiamo davvero inviando dati
                ...(hasBody && { 'Content-Type': 'application/json' }),
                ...options.headers
            },
            body: hasBody ? JSON.stringify(options.body) : undefined
        });

        // 1. Controllo se la risposta è OK (status 200-299)
        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.message || `Errore HTTP: ${response.status}`);
        }

        // 2. Gestione sicura del JSON (per evitare crash su risposte vuote 204)
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.includes("application/json")) {
            return await response.json();
        }

        return null; // O un oggetto vuoto {}
    } catch (err) {
        console.error("Errore nella chiamata al BFF:", err);
        throw err; // Importante: lancia l'errore così il componente React può gestirlo
    }
}